import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@material-ui/core";
import axios from "axios";
import { URL } from "../../config/config";
import BvbpDialog from "./BvbpDialog";

// AiSensy KYC tab: submit any direct (non-partner) project to Meta by its
// project id, even if it never went through our in-dashboard KYC.
const KycDirectApply = ({ alertHandler, setTemplateData }) => {
  const [lookupOpen, setLookupOpen] = useState(false);
  const [projectId, setProjectId] = useState("");
  const [checking, setChecking] = useState(false);
  const [blockers, setBlockers] = useState([]);
  const [assistant, setAssistant] = useState(null);

  const closeLookup = () => {
    setLookupOpen(false);
    setProjectId("");
    setBlockers([]);
  };

  const checkProject = () => {
    const assistantId = projectId.trim();
    if (!assistantId) return;
    setChecking(true);
    setBlockers([]);
    axios
      .get(`${URL}/superadmin/kyc-apply-check`, { params: { assistantId } })
      .then((response) => {
        const { eligible, blockers: reasons, assistant: found } =
          response.data || {};
        if (eligible && found) {
          closeLookup();
          setAssistant(found);
        } else {
          setBlockers(reasons?.length ? reasons : ["Project not eligible"]);
        }
      })
      .catch((error) => {
        console.error(error);
        alertHandler(true, "Failed to check project", "error");
      })
      .finally(() => setChecking(false));
  };

  return (
    <>
      <Button
        color="primary"
        variant="contained"
        onClick={() => setLookupOpen(true)}
      >
        Apply by Project ID
      </Button>

      <Dialog open={lookupOpen} onClose={closeLookup} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Typography variant="h3">Apply by Project ID</Typography>
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            label="Project ID"
            value={projectId}
            onChange={(e) => setProjectId(e.target.value)}
            onKeyPress={(e) => e.key === "Enter" && checkProject()}
          />
          {blockers.length > 0 && (
            <Box mt={2}>
              <Typography variant="h5" color="error">
                Can't submit this project:
              </Typography>
              {blockers.map((reason) => (
                <Typography key={reason} variant="body1" color="error">
                  • {reason}
                </Typography>
              ))}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeLookup} color="primary" variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={checkProject}
            color="primary"
            variant="contained"
            disabled={checking || !projectId.trim()}
          >
            {checking ? "Checking..." : "Check"}
          </Button>
        </DialogActions>
      </Dialog>

      {assistant && (
        <BvbpDialog
          value={0}
          open
          hideStepActions
          toggleDialog={() => setAssistant(null)}
          AssistantsDetails={assistant}
          hasWriteAccess
          alertHandler={alertHandler}
          setTemplateData={setTemplateData}
        />
      )}
    </>
  );
};

export default KycDirectApply;
